import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconColorFan12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconColorFan12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1 9.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5m0-1.415.09-.028L3 4.748V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm1.563-.58 3.464-2L7.04 3.75a.5.5 0 0 0-.183-.683l-.866-.5a.5.5 0 0 0-.683.183zM3.706 8h4l2.08-1.2a.5.5 0 0 0 .182-.684l-.5-.866a.5.5 0 0 0-.683-.183zm6 0h.794A1.5 1.5 0 0 1 12 9.5v1a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 10.5v-8A1.5 1.5 0 0 1 1.5 1h1A1.5 1.5 0 0 1 4 2.5v.516l.442-.766a1.5 1.5 0 0 1 2.05-.549l.865.5a1.5 1.5 0 0 1 .55 2.05l-.148.254.526-.304a1.5 1.5 0 0 1 2.05.55l.5.865a1.5 1.5 0 0 1-.55 2.05z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconColorFan12);
